import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 528 528"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M408 32a63.621 63.621 0 0 0-35.828 11.003C363.43 18.054 339.897 0 312 0c-19.205 0-36.26 8.679-48 22.118C252.26 8.679 235.205 0 216 0c-27.896 0-51.43 18.054-60.172 43.003A63.621 63.621 0 0 0 120 32c-35.289 0-64 28.711-64 64s28.711 64 64 64c39.07 0 64 66.336 64 112v176c0 44.109 35.891 80 80 80s80-35.891 80-80V272c0-45.664 24.93-112 64-112 35.289 0 64-28.711 64-64s-28.711-64-64-64zm-224.891 86.613C192.756 124.444 203.93 128 216 128c5.557 0 10.855-.936 16-2.272v62.418c-11.086-28.116-27.629-52.809-48.891-69.533zM296 188.145v-62.418c5.145 1.337 10.443 2.272 16 2.272 12.07 0 23.244-3.556 32.891-9.387-21.262 16.725-37.805 41.418-48.891 69.533z" }, null, -1)
  ])))
}
export default { render: render }